export const calculateStreak = (questions) => {
    if (questions.length === 0) return 0;
  
    const sortedDates = [...new Set(questions.map((q) => q.date))].sort(
      (a, b) => new Date(b) - new Date(a)
    );
  
    let currentStreak = 0;
    for (let i = 0; i < sortedDates.length; i++) {
      const date = new Date(sortedDates[i]);
      const expectedDate = new Date();
      expectedDate.setDate(expectedDate.getDate() - i);
  
      if (date.toLocaleDateString() === expectedDate.toLocaleDateString()) {
        currentStreak++;
      } else {
        break;
      }
    }
    return currentStreak;
  };
  
  export const getAchievementLevel = (count) => {
    if (count >= 500)
      return { level: 'Legend', icon: '👑', color: 'achievement-legend' };
    if (count >= 300)
      return { level: 'Expert', icon: '⭐', color: 'achievement-expert' };
    if (count >= 150)
      return { level: 'Advanced', icon: '🚀', color: 'achievement-advanced' };
    if (count >= 50)
      return {
        level: 'Intermediate',
        icon: '💪',
        color: 'achievement-intermediate',
      };
    if (count >= 10)
      return { level: 'Beginner', icon: '🌱', color: 'achievement-beginner' };
    return { level: 'Newbie', icon: '🐣', color: 'achievement-newbie' };
  };
  
  export const exportToJSON = (questions) => {
    const dataStr = JSON.stringify(questions, null, 2);
    const dataBlob = new Blob([dataStr], { type: 'application/json' });
    const url = URL.createObjectURL(dataBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `dsa-tracker-${new Date().toISOString().split('T')[0]}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };
  
  export const exportToCSV = (questions) => {
    const headers = [
      'Title',
      'Platform',
      'Difficulty',
      'Algorithm',
      'Date',
      'Attempted',
      'Starred',
      'Time Taken',
      'Time Complexity',
      'Space Complexity',
      'Problem URL',
    ];
  
    const rows = questions.map((q) => [
      q.title,
      q.platform,
      q.difficulty,
      q.algorithm,
      q.date,
      q.attempted ? 'Yes' : 'No',
      q.starred ? 'Yes' : 'No',
      q.timeTaken || '',
      q.timeComplexity || '',
      q.spaceComplexity || '',
      q.problemUrl || '',
    ]);
  
    const csvContent = [
      headers.join(','),
      ...rows.map((row) => row.map((cell) => `"${cell}"`).join(',')),
    ].join('\n');
  
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `dsa-tracker-${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };